/* eslint-disable */
import React from "react";
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import BubbleChart from "@material-ui/icons/BubbleChart";
import LocationOn from "@material-ui/icons/LocationOn";
import Notifications from "@material-ui/icons/Notifications";
import EventIcon from "@material-ui/icons/Event";
import Redeem from "@material-ui/icons/Redeem";
import { Home, set_meal, Store } from "@material-ui/icons";
import trophy from "@material-ui/icons/EmojiEvents";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faFish } from "@fortawesome/free-solid-svg-icons";
import WavesIcon from "@material-ui/icons/Waves";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";

import Unarchive from "@material-ui/icons/Unarchive";
import Language from "@material-ui/icons/Language";
// core components/views for Admin layout
import DashboardPage from "views/Dashboard/Dashboard.js";
import DrawWinner from "views/DrawWinner/DrawWinner.js";
import customerlogout from "views/CustomerPanel/CustomerLogOut/CustomerLogOut.js"
import Event from "views/Events/Event.js";
import Prize from "views/Prize/prize.js";
import Shop from "views/Shop/shop.js";
import fishermen from "views/Fishermen/Fishermen.js";
import Sponsors from "views/Sponsors/Sponsors.js";
import Customer from "views/Customer/customers.js";
import PeopleIcon from "@material-ui/icons/People";
import EventRegistration from "views/CustomerPanel/EventRegistration/EventRegistration.js";
import MyPrize from "views/CustomerPanel/MyPrize/MyPrize.js";
import MyFish from "views/CustomerPanel/MyFish/MyFish.js";
import Chances from "views/CustomerPanel/Chances/chances";
import CasinoIcon from '@material-ui/icons/Casino';

const dashboardRoutes = [
  {
    path: "/EventRegistration",
    name: "Event Registration",
    icon: EventIcon,
    component: EventRegistration,
    layout: "/customer",
  },

  {
    path: "/MyPrize",
    name: "My Prize",
    icon: trophy,
    component: MyPrize,
    layout: "/customer",
  },

  {
    path: "/MyFish",
    name: "My Fish",
    icon: WavesIcon,
    component: MyFish,
    layout: "/customer",
  },
  {
    path: "/chances",
    name: "Chances",
    icon: CasinoIcon,
    component: Chances,
    layout: "/customer",
  },

  {
    path: "/logout",
    name: "LogOut",
    icon: ExitToAppIcon,
    component: customerlogout,
    layout: "/customer",
  },
];

export default dashboardRoutes;
